'use client';

import { Translation } from '@/hoslog-intl';
import { cva } from 'class-variance-authority';
import { Checkbox as Root } from 'ui/checkbox';

interface CheckboxProps extends React.ComponentProps<typeof Root> {
  size?: 'sm' | 'lg';
  variant?: 'filled' | 'outline';
  color?: string;
  label?: string;
}

const checkboxStyles = cva('data-[state=checked]:border-[var(--checkbox-color)] text-secondary', {
  variants: {
    size: {
      sm: 'size-4',
      lg: 'size-5',
    },
    variant: {
      filled:
        'data-[state=checked]:bg-[var(--checkbox-color)] text-muted data-[state=checked]:text-primary-foreground ',
      outline: ' data-[state=checked]:text-[var(--checkbox-color)]',
    },
  },
  defaultVariants: {
    size: 'sm',
    variant: 'filled',
  },
});

export function Checkbox(props: CheckboxProps) {
  const { size = 'sm', variant = 'filled', label, title, color = 'var(--success)', ...restProps } = props;
  const defaultColor = color ?? 'var(--success)';

  return (
    <div className="flex items-center space-x-2">
      <Root
        {...restProps}
        className={checkboxStyles({ size, variant })}
        style={
          {
            '--checkbox-color': defaultColor,
          } as React.CSSProperties
        }
        {...props}
      />
      {label && (
        <label htmlFor={label} className="text-xs cursor-pointer">
          <Translation id={label} />
        </label>
      )}
      {title && <span className="text-xs cursor-pointer">{title}</span>}
    </div>
  );
}
